/**
 * SunnyIcon — sanitized from `assets/newSvg/sunny.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function SunnyIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M5.66861,4.76019 C5.78724,3.78065 6.80341,3.19555 7.70988,3.58326 C8.77068,4.03697 11.151,5.11563 14.1712,6.85935 C17.1921,8.60347 19.3167,10.1258 20.2396,10.8174 C21.028,11.4082 21.0303,12.5803 20.2411,13.1729 C19.3266,13.8596 17.2277,15.3637 14.1701,17.129 C11.1115,18.8949 8.75886,19.9607 7.70749,20.4091 C6.80076,20.7957 5.78729,20.2095 5.66885,19.232 C5.53051,18.0902 5.27335,15.4973 5.27335,11.9951 C5.27335,8.49493 5.53021,5.90304 5.66861,4.76019 Z"
        fill={color}
      />
    </Svg>
  );
}

export default SunnyIcon;
